import { useEffect } from "react";
import useWindowSize from "./useWindowSize";

export default function ScorecardGraph({
	Highcharts,
	graphResult,
	form_name = "Scorecard Result",
	from = "",
	firstname = "",
}) {
	const { width } = useWindowSize();

	useEffect(() => {
		let div_scorecard_graph = document.getElementById("div_scorecard_graph");

		if (div_scorecard_graph) {
			let categories = graphResult.map((item) => item.name);

			let chartProps = {
				polar: true,
				type: "column",
				height: 550,
				events: {
					render: function () {
						let chart = this;

						let labels = categories || [];
						let series = chart.series && chart.series[0];
						let spacing = chart.plotWidth / Math.max(labels.length, 1);

						// destroy previous top labels/bars (if any)
						if (chart._topLabels) {
							chart._topLabels.forEach((el) => el.destroy());
						}
						chart._topLabels = [];

						labels.forEach((lbl, i) => {
							let point = series && series.data && series.data[i];

							// Responsive margin and spacing
							let baseMarginLeft = 30;
							let baseTopY =
								from === "scorecard_send" ? 70 : width >= 576 ? 100 : 80;
							let baseFontSize = from === "scorecard_send" ? 16 : 12;
							let baseCircleR = 4;

							// Adjust based on chart width
							let scale =
								chart.chartWidth < 400
									? 0.7
									: chart.chartWidth < 600
									? 0.85
									: 1;

							if (from === "scorecard_send") {
								scale = 1;
							}

							let marginLeft = baseMarginLeft * scale;

							let x = chart.plotLeft + i * spacing + spacing / 2 + marginLeft;
							let topY = chart.plotTop - baseTopY * scale;
							let fontSize = `${baseFontSize * scale}px`;
							let circleR = baseCircleR * scale;
							let containerBoxWidth = chart.containerBox.width;

							console.log("width: ", width);

							if (from !== "scorecard_send") {
								if (i % 2 === 1) {
									let newAddY = 80;
									topY = chart.plotTop - newAddY * scale;
									x =
										chart.plotLeft +
										i * spacing -
										(spacing / 2.7) * scale +
										marginLeft +
										3 * scale;
								}

								if (i === 0) {
									// work life

									if (width <= 485) {
										topY = chart.plotTop - 140 * scale;
										x = chart.plotLeft + 80;
									} else if (width <= 575) {
										topY = chart.plotTop - 140 * scale;
										x = chart.plotLeft + 155;
									}
								} else if (i === 7) {
									// finances

									if (width <= 575) {
										baseTopY = 120;
									}

									topY = chart.plotTop - baseTopY * scale;

									let addX = 302;
									if (width > 1600) {
										addX = 302;
									} else if (width > 1400) {
										addX = 220;
									} else if (width > 1200) {
										addX = 180;
									} else if (width > 1024) {
										addX = 180;
									} else if (width > 800) {
										addX = 190;
									} else if (width > 575) {
										addX = 180;
									} else if (width > 485) {
										addX = 153;
									} else {
										addX = 78;
									}
									x = chart.plotLeft + addX;
								} else if (i === 6) {
									// holidays

									if (width <= 575) {
										topY = chart.plotTop - 100 * scale;
									}

									let addX =
										width > 1600
											? 380
											: width > 1400
											? 335
											: width > 1200
											? 316
											: 230;
									x = containerBoxWidth - addX;

									if (width <= 485) {
										x = chart.plotLeft + 78;
									} else if (width <= 575) {
										x = chart.plotLeft + 152;
									}
								} else if (i === 5) {
									// recreation

									if (width <= 575) {
										baseTopY = 80;
									}

									topY = chart.plotTop - baseTopY * scale;
									let addX = width > 1200 ? 180 : 127;
									x = containerBoxWidth - addX;

									if (width <= 485) {
										x = chart.plotLeft + 86;
									} else if (width <= 575) {
										x = chart.plotLeft + 160;
									}
								} else if (i === 1) {
									// relationships
									x =
										chart.plotLeft +
										i * spacing -
										(spacing / 2.7) * scale +
										marginLeft +
										0 * scale;

									if (width <= 375) {
										topY = chart.plotTop - 140 * scale;
										x = containerBoxWidth - 118;
									} else if (width <= 485) {
										topY = chart.plotTop - 140 * scale;
										x = containerBoxWidth - 120;
									} else if (width <= 575) {
										topY = chart.plotTop - 140 * scale;
										x = containerBoxWidth - 180;
									}
								} else if (i === 2) {
									// home
									topY = chart.plotTop - 80 * scale;
									let addX = 290;
									if (width > 1600) {
										addX = 290;
									} else if (width > 1400) {
										addX = 208;
									} else if (width > 1200) {
										addX = 170;
									} else if (width > 1024) {
										addX = 170;
									} else if (width > 800) {
										addX = 180;
									} else if (width > 575) {
										addX = 170;
									} else if (width > 485) {
										addX = 160;
									} else {
										addX = 85;
									}

									x = chart.plotLeft + addX;

									if (width <= 485) {
										topY = chart.plotTop - 120 * scale;
										x = containerBoxWidth - 145;
									} else if (width <= 575) {
										topY = chart.plotTop - 120 * scale;
										x = containerBoxWidth - 205;
									}
								} else if (i === 3) {
									// health
									topY = chart.plotTop - 80 * scale;
									let addX =
										width > 1600
											? 385
											: width > 1400
											? 340
											: width > 1200
											? 320
											: 235;
									x = containerBoxWidth - addX;

									if (width <= 375) {
										topY = chart.plotTop - 100 * scale;
										x = containerBoxWidth - 133;
									} else if (width <= 485) {
										topY = chart.plotTop - 100 * scale;
										x = containerBoxWidth - 140;
									} else if (width <= 575) {
										topY = chart.plotTop - 100 * scale;
										x = containerBoxWidth - 200;
									}
								} else if (i === 4) {
									// sense of belonging
									topY = chart.plotTop - 80 * scale;
									let addX = width > 1200 ? 148 : 100;
									x = containerBoxWidth - addX;

									if (width <= 485) {
										topY = chart.plotTop - 80 * scale;
										x = containerBoxWidth - 100;
									} else if (width <= 575) {
										topY = chart.plotTop - 80 * scale;
										x = containerBoxWidth - 160;
									}
								}
							} else {
								let containerBoxWidth = chart.containerBox.width;
								if (i === 0) {
									topY = chart.plotTop + 150;
									x = chart.plotLeft + 170;
								} else if (i === 7) {
									topY = chart.plotTop + 180;
									x = chart.plotLeft + 165;
								} else if (i === 6) {
									topY = chart.plotTop + 210;
									x = chart.plotLeft + 165;
								} else if (i === 5) {
									topY = chart.plotTop + 240;
									x = chart.plotLeft + 175;
								} else if (i === 1) {
									topY = chart.plotTop + 150;
									x = containerBoxWidth - 148;
								} else if (i === 2) {
									topY = chart.plotTop + 180;
									x = containerBoxWidth - 188;
								} else if (i === 3) {
									topY = chart.plotTop + 210;
									x = containerBoxWidth - 181;
								} else if (i === 4) {
									topY = chart.plotTop + 240;
									x = containerBoxWidth - 120;
								}
							}

							// create category text
							const cat = chart.renderer
								.text(lbl, x, topY)
								.attr({ align: "center" })
								.css({
									fontSize,
									color: from === "scorecard_send" ? "#000" : point.color,
								})
								.add();

							if (cat && cat.element) {
								cat.element.setAttribute("text-anchor", "middle");
								cat.element.setAttribute(
									"fill",
									(point && point.color) || "#000"
								);
							}

							// measure text box
							const bbox = cat.getBBox();

							// circle center (left edge of text, vertically centered)
							const circleCX = bbox.x - 14 * scale;
							const circleCY = bbox.y + bbox.height / 2;
							// draw solid circle
							const circle = chart.renderer
								.circle(circleCX, circleCY, circleR)
								.attr({
									fill: (point && point.color) || "#000",
									stroke: (point && point.color) || "#000",
									"stroke-width": 2 * scale,
								})
								.add();

							chart._topLabels.push(cat, circle);
						});
					},
				},
				marginTop: from === "scorecard_send" ? 50 : width >= 576 ? 130 : 150, // add extra space at bottom
				marginBottom: 30,
			};

			Highcharts.chart("div_scorecard_graph", {
				chart: chartProps,
				title: {
					text: firstname
						? `${firstname.toUpperCase()}'S HAPPINESS SCORE`
						: "HAPPINESS SCORE",
					y: from === "scorecard_send" ? 10 : width >= 576 ? 90 : 120,
					style: { fontSize: "20px", fontWeight: "bold" },
				},
				pane: {
					size: "100%", // makes it round like a pie
				},
				xAxis: {
					categories: categories,
					labels: {
						// useHTML: true,
						formatter: function () {
							// let colors = [
							// 	"#000",
							// 	"#000",
							// 	"#000",
							// 	"#000",
							// 	"#000",
							// 	"#000",
							// 	"#000",
							// 	"000",
							// ];
							let chart = this.chart;
							let series = chart.series[0]; // first series
							let { yData } = series;
							let point = yData[this.pos]; // corresponding point
							// let pointColor = colors[this.pos];
							if (point) {
								// return `<span style="color: ${pointColor}">${point}</span>`;

								return Number.isInteger(point)
									? Number(point.toFixed(2))
									: point;
							}
							return 0;
						},
						distance: -145,
						style: { fontSize: "0.8em" },
						allowOverlap: true,
					},
					lineWidth: 0,
				},
				yAxis: {
					min: 0,
					max: 25,
					tickInterval: 5, // radial tick values
					endOnTick: true,
					gridLineColor: "#e6e6e6",
					gridLineWidth: 1,
					showLastLabel: true,
					maxPadding: 0,
					labels: {
						format: "{value}", // show tick numbers
						style: { fontSize: "0.5em", color: "#888" },
					},
				},
				tooltip: {
					formatter: function () {
						const category = categories[this.point.x]; // 👈 match index to categories
						return `<b>${category}</b><br/>Total: ${this.y}`;
					},
				},
				credits: false,
				legend: {
					align: "center",
					verticalAlign: "top",
					layout: "horizontal",
				},
				plotOptions: {
					series: {
						pointPadding: 0, // remove padding between points
						groupPadding: 0, // remove group spacing
						borderWidth: 0, // remove white borders
						pointPlacement: "between",
					},
				},
				series: [
					{
						name: form_name,
						data: graphResult,
						pointPlacement: "on",
						fillOpacity: 0.6,
						showInLegend: false, // ensure legend is shown
					},
				],
			});
		}

		return () => {
			div_scorecard_graph = null;
		};
		// eslint-disable-next-line
	}, [graphResult, firstname]);

	return <div id="div_scorecard_graph" />;
}
